/* tslint:disable */
/* eslint-disable */
/**
 * OpenShifts.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { BaseResponse } from '../api-models';
// @ts-ignore
import { BaseResponseOfIEnumerableOfViewUnitAvailableDto } from '../api-models';
// @ts-ignore
import { BaseResponseOfViewOpeningTemplateDto } from '../api-models';
// @ts-ignore
import { BaseScheduleRecord } from '../api-models';
// @ts-ignore
import { BulkUpdateOpeningTemplateResponse } from '../api-models';
// @ts-ignore
import { CreateOpeningTemplate } from '../api-models';
// @ts-ignore
import { ImportBudgetsRequest } from '../api-models';
// @ts-ignore
import { UpdateOpeningTemplateDto } from '../api-models';
// @ts-ignore
import { ViewOpeningTemplateDto } from '../api-models';
/**
 * OpeningTemplateApi - axios parameter creator
 * @export
 */
export const OpeningTemplateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [positionId] 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openingTemplateBaseSchedulesGet: async (departmentId?: number, positionId?: number, facilityId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/OpeningTemplate/base-schedules`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint accepts a collection of OpenShifts.BusinessObjects.Scheduler.DTOs.UpdateOpeningTemplateDto objects and updates the corresponding opening templates in the system.    Each template is updated with the provided field values, and the overall result of the operation is returned.
         * @summary Performs a bulk update of existing opening templates.
         * @param {Array<UpdateOpeningTemplateDto>} [updateOpeningTemplateDto] A list of OpenShifts.BusinessObjects.Scheduler.DTOs.UpdateOpeningTemplateDto objects containing the updated data for each opening template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openingTemplateBulkUpdateOpeningTemplatesPost: async (updateOpeningTemplateDto?: Array<UpdateOpeningTemplateDto>, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/OpeningTemplate/bulk-update-opening-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOpeningTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} [facilityId] 
         * @param {number} [departmentId] 
         * @param {number} [positionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openingTemplateGet: async (facilityId?: number, departmentId?: number, positionId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/OpeningTemplate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * This endpoint processes an OpenShifts.BusinessObjects.Scheduler.Request.ImportBudgetsRequest that includes filters and default values.    It retrieves matching budgets from the system and generates corresponding opening templates.
         * @summary Imports legacy budget data and converts it into opening templates.
         * @param {ImportBudgetsRequest} [importBudgetsRequest] The request payload containing filters for specific facilities, departments, positions, or units.    It also includes ratio data to apply to the created opening templates and may specify a default department    to use when a budget entry does not include one.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openingTemplateImportBudgetsPost: async (importBudgetsRequest?: ImportBudgetsRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/OpeningTemplate/import-budgets`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(importBudgetsRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} openingTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openingTemplateOpeningTemplateIdDelete: async (openingTemplateId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'openingTemplateId' is not null or undefined
            assertParamExists('openingTemplateOpeningTemplateIdDelete', 'openingTemplateId', openingTemplateId)
            const localVarPath = `/OpeningTemplate/{openingTemplateId}`
                .replace(`{${"openingTemplateId"}}`, encodeURIComponent(String(openingTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} openingTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openingTemplateOpeningTemplateIdGet: async (openingTemplateId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'openingTemplateId' is not null or undefined
            assertParamExists('openingTemplateOpeningTemplateIdGet', 'openingTemplateId', openingTemplateId)
            const localVarPath = `/OpeningTemplate/{openingTemplateId}`
                .replace(`{${"openingTemplateId"}}`, encodeURIComponent(String(openingTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} openingTemplateId 
         * @param {UpdateOpeningTemplateDto} [updateOpeningTemplateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openingTemplateOpeningTemplateIdPut: async (openingTemplateId: number, updateOpeningTemplateDto?: UpdateOpeningTemplateDto, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'openingTemplateId' is not null or undefined
            assertParamExists('openingTemplateOpeningTemplateIdPut', 'openingTemplateId', openingTemplateId)
            const localVarPath = `/OpeningTemplate/{openingTemplateId}`
                .replace(`{${"openingTemplateId"}}`, encodeURIComponent(String(openingTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateOpeningTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [date] 
         * @param {number} [positionId] 
         * @param {number} [shiftTypeId] 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openingTemplateOpeningtemplatesByTypeAndPositionGet: async (date?: string, positionId?: number, shiftTypeId?: number, departmentId?: number, facilityId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/OpeningTemplate/openingtemplates-by-type-and-position`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (date !== undefined) {
                localVarQueryParameter['date'] = (date as any instanceof Date) ?
                    (date as any).toISOString() :
                    date;
            }

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }

            if (shiftTypeId !== undefined) {
                localVarQueryParameter['shiftTypeId'] = shiftTypeId;
            }

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {CreateOpeningTemplate} [createOpeningTemplate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openingTemplatePost: async (createOpeningTemplate?: CreateOpeningTemplate, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/OpeningTemplate`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createOpeningTemplate, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary One time script
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {number} [shiftTypeId] 
         * @param {number} [positionId] 
         * @param {number} [unitId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openingTemplateSearchGet: async (departmentId?: number, facilityId?: number, shiftTypeId?: number, positionId?: number, unitId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/OpeningTemplate/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (departmentId !== undefined) {
                localVarQueryParameter['departmentId'] = departmentId;
            }

            if (facilityId !== undefined) {
                localVarQueryParameter['facilityId'] = facilityId;
            }

            if (shiftTypeId !== undefined) {
                localVarQueryParameter['shiftTypeId'] = shiftTypeId;
            }

            if (positionId !== undefined) {
                localVarQueryParameter['positionId'] = positionId;
            }

            if (unitId !== undefined) {
                localVarQueryParameter['unitId'] = unitId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OpeningTemplateApi - functional programming interface
 * @export
 */
export const OpeningTemplateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = OpeningTemplateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [departmentId] 
         * @param {number} [positionId] 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openingTemplateBaseSchedulesGet(departmentId?: number, positionId?: number, facilityId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<BaseScheduleRecord>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openingTemplateBaseSchedulesGet(departmentId, positionId, facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint accepts a collection of OpenShifts.BusinessObjects.Scheduler.DTOs.UpdateOpeningTemplateDto objects and updates the corresponding opening templates in the system.    Each template is updated with the provided field values, and the overall result of the operation is returned.
         * @summary Performs a bulk update of existing opening templates.
         * @param {Array<UpdateOpeningTemplateDto>} [updateOpeningTemplateDto] A list of OpenShifts.BusinessObjects.Scheduler.DTOs.UpdateOpeningTemplateDto objects containing the updated data for each opening template.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openingTemplateBulkUpdateOpeningTemplatesPost(updateOpeningTemplateDto?: Array<UpdateOpeningTemplateDto>, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BulkUpdateOpeningTemplateResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openingTemplateBulkUpdateOpeningTemplatesPost(updateOpeningTemplateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} [facilityId] 
         * @param {number} [departmentId] 
         * @param {number} [positionId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openingTemplateGet(facilityId?: number, departmentId?: number, positionId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ViewOpeningTemplateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openingTemplateGet(facilityId, departmentId, positionId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * This endpoint processes an OpenShifts.BusinessObjects.Scheduler.Request.ImportBudgetsRequest that includes filters and default values.    It retrieves matching budgets from the system and generates corresponding opening templates.
         * @summary Imports legacy budget data and converts it into opening templates.
         * @param {ImportBudgetsRequest} [importBudgetsRequest] The request payload containing filters for specific facilities, departments, positions, or units.    It also includes ratio data to apply to the created opening templates and may specify a default department    to use when a budget entry does not include one.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openingTemplateImportBudgetsPost(importBudgetsRequest?: ImportBudgetsRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CreateOpeningTemplate>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openingTemplateImportBudgetsPost(importBudgetsRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} openingTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openingTemplateOpeningTemplateIdDelete(openingTemplateId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openingTemplateOpeningTemplateIdDelete(openingTemplateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} openingTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openingTemplateOpeningTemplateIdGet(openingTemplateId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfViewOpeningTemplateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openingTemplateOpeningTemplateIdGet(openingTemplateId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {number} openingTemplateId 
         * @param {UpdateOpeningTemplateDto} [updateOpeningTemplateDto] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openingTemplateOpeningTemplateIdPut(openingTemplateId: number, updateOpeningTemplateDto?: UpdateOpeningTemplateDto, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfViewOpeningTemplateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openingTemplateOpeningTemplateIdPut(openingTemplateId, updateOpeningTemplateDto, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [date] 
         * @param {number} [positionId] 
         * @param {number} [shiftTypeId] 
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openingTemplateOpeningtemplatesByTypeAndPositionGet(date?: string, positionId?: number, shiftTypeId?: number, departmentId?: number, facilityId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfIEnumerableOfViewUnitAvailableDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openingTemplateOpeningtemplatesByTypeAndPositionGet(date, positionId, shiftTypeId, departmentId, facilityId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {CreateOpeningTemplate} [createOpeningTemplate] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openingTemplatePost(createOpeningTemplate?: CreateOpeningTemplate, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BaseResponseOfViewOpeningTemplateDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openingTemplatePost(createOpeningTemplate, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary One time script
         * @param {number} [departmentId] 
         * @param {number} [facilityId] 
         * @param {number} [shiftTypeId] 
         * @param {number} [positionId] 
         * @param {number} [unitId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async openingTemplateSearchGet(departmentId?: number, facilityId?: number, shiftTypeId?: number, positionId?: number, unitId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ViewOpeningTemplateDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.openingTemplateSearchGet(departmentId, facilityId, shiftTypeId, positionId, unitId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * OpeningTemplateApi - factory interface
 * @export
 */
export const OpeningTemplateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = OpeningTemplateApiFp(configuration)
    return {
        /**
         * 
         * @param {OpeningTemplateApiOpeningTemplateBaseSchedulesGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openingTemplateBaseSchedulesGet(requestParameters: OpeningTemplateApiOpeningTemplateBaseSchedulesGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<BaseScheduleRecord>> {
            return localVarFp.openingTemplateBaseSchedulesGet(requestParameters.departmentId, requestParameters.positionId, requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint accepts a collection of OpenShifts.BusinessObjects.Scheduler.DTOs.UpdateOpeningTemplateDto objects and updates the corresponding opening templates in the system.    Each template is updated with the provided field values, and the overall result of the operation is returned.
         * @summary Performs a bulk update of existing opening templates.
         * @param {OpeningTemplateApiOpeningTemplateBulkUpdateOpeningTemplatesPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openingTemplateBulkUpdateOpeningTemplatesPost(requestParameters: OpeningTemplateApiOpeningTemplateBulkUpdateOpeningTemplatesPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BulkUpdateOpeningTemplateResponse> {
            return localVarFp.openingTemplateBulkUpdateOpeningTemplatesPost(requestParameters.updateOpeningTemplateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OpeningTemplateApiOpeningTemplateGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openingTemplateGet(requestParameters: OpeningTemplateApiOpeningTemplateGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<ViewOpeningTemplateDto>> {
            return localVarFp.openingTemplateGet(requestParameters.facilityId, requestParameters.departmentId, requestParameters.positionId, options).then((request) => request(axios, basePath));
        },
        /**
         * This endpoint processes an OpenShifts.BusinessObjects.Scheduler.Request.ImportBudgetsRequest that includes filters and default values.    It retrieves matching budgets from the system and generates corresponding opening templates.
         * @summary Imports legacy budget data and converts it into opening templates.
         * @param {OpeningTemplateApiOpeningTemplateImportBudgetsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openingTemplateImportBudgetsPost(requestParameters: OpeningTemplateApiOpeningTemplateImportBudgetsPostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<CreateOpeningTemplate>> {
            return localVarFp.openingTemplateImportBudgetsPost(requestParameters.importBudgetsRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OpeningTemplateApiOpeningTemplateOpeningTemplateIdDeleteRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openingTemplateOpeningTemplateIdDelete(requestParameters: OpeningTemplateApiOpeningTemplateOpeningTemplateIdDeleteRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponse> {
            return localVarFp.openingTemplateOpeningTemplateIdDelete(requestParameters.openingTemplateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OpeningTemplateApiOpeningTemplateOpeningTemplateIdGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openingTemplateOpeningTemplateIdGet(requestParameters: OpeningTemplateApiOpeningTemplateOpeningTemplateIdGetRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfViewOpeningTemplateDto> {
            return localVarFp.openingTemplateOpeningTemplateIdGet(requestParameters.openingTemplateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OpeningTemplateApiOpeningTemplateOpeningTemplateIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openingTemplateOpeningTemplateIdPut(requestParameters: OpeningTemplateApiOpeningTemplateOpeningTemplateIdPutRequest, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfViewOpeningTemplateDto> {
            return localVarFp.openingTemplateOpeningTemplateIdPut(requestParameters.openingTemplateId, requestParameters.updateOpeningTemplateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OpeningTemplateApiOpeningTemplateOpeningtemplatesByTypeAndPositionGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openingTemplateOpeningtemplatesByTypeAndPositionGet(requestParameters: OpeningTemplateApiOpeningTemplateOpeningtemplatesByTypeAndPositionGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfIEnumerableOfViewUnitAvailableDto> {
            return localVarFp.openingTemplateOpeningtemplatesByTypeAndPositionGet(requestParameters.date, requestParameters.positionId, requestParameters.shiftTypeId, requestParameters.departmentId, requestParameters.facilityId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {OpeningTemplateApiOpeningTemplatePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openingTemplatePost(requestParameters: OpeningTemplateApiOpeningTemplatePostRequest = {}, options?: AxiosRequestConfig): AxiosPromise<BaseResponseOfViewOpeningTemplateDto> {
            return localVarFp.openingTemplatePost(requestParameters.createOpeningTemplate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary One time script
         * @param {OpeningTemplateApiOpeningTemplateSearchGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        openingTemplateSearchGet(requestParameters: OpeningTemplateApiOpeningTemplateSearchGetRequest = {}, options?: AxiosRequestConfig): AxiosPromise<Array<ViewOpeningTemplateDto>> {
            return localVarFp.openingTemplateSearchGet(requestParameters.departmentId, requestParameters.facilityId, requestParameters.shiftTypeId, requestParameters.positionId, requestParameters.unitId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for openingTemplateBaseSchedulesGet operation in OpeningTemplateApi.
 * @export
 * @interface OpeningTemplateApiOpeningTemplateBaseSchedulesGetRequest
 */
export interface OpeningTemplateApiOpeningTemplateBaseSchedulesGetRequest {
    /**
     * 
     * @type {number}
     * @memberof OpeningTemplateApiOpeningTemplateBaseSchedulesGet
     */
    readonly departmentId?: number

    /**
     * 
     * @type {number}
     * @memberof OpeningTemplateApiOpeningTemplateBaseSchedulesGet
     */
    readonly positionId?: number

    /**
     * 
     * @type {number}
     * @memberof OpeningTemplateApiOpeningTemplateBaseSchedulesGet
     */
    readonly facilityId?: number
}

/**
 * Request parameters for openingTemplateBulkUpdateOpeningTemplatesPost operation in OpeningTemplateApi.
 * @export
 * @interface OpeningTemplateApiOpeningTemplateBulkUpdateOpeningTemplatesPostRequest
 */
export interface OpeningTemplateApiOpeningTemplateBulkUpdateOpeningTemplatesPostRequest {
    /**
     * A list of OpenShifts.BusinessObjects.Scheduler.DTOs.UpdateOpeningTemplateDto objects containing the updated data for each opening template.
     * @type {Array<UpdateOpeningTemplateDto>}
     * @memberof OpeningTemplateApiOpeningTemplateBulkUpdateOpeningTemplatesPost
     */
    readonly updateOpeningTemplateDto?: Array<UpdateOpeningTemplateDto>
}

/**
 * Request parameters for openingTemplateGet operation in OpeningTemplateApi.
 * @export
 * @interface OpeningTemplateApiOpeningTemplateGetRequest
 */
export interface OpeningTemplateApiOpeningTemplateGetRequest {
    /**
     * 
     * @type {number}
     * @memberof OpeningTemplateApiOpeningTemplateGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {number}
     * @memberof OpeningTemplateApiOpeningTemplateGet
     */
    readonly departmentId?: number

    /**
     * 
     * @type {number}
     * @memberof OpeningTemplateApiOpeningTemplateGet
     */
    readonly positionId?: number
}

/**
 * Request parameters for openingTemplateImportBudgetsPost operation in OpeningTemplateApi.
 * @export
 * @interface OpeningTemplateApiOpeningTemplateImportBudgetsPostRequest
 */
export interface OpeningTemplateApiOpeningTemplateImportBudgetsPostRequest {
    /**
     * The request payload containing filters for specific facilities, departments, positions, or units.    It also includes ratio data to apply to the created opening templates and may specify a default department    to use when a budget entry does not include one.
     * @type {ImportBudgetsRequest}
     * @memberof OpeningTemplateApiOpeningTemplateImportBudgetsPost
     */
    readonly importBudgetsRequest?: ImportBudgetsRequest
}

/**
 * Request parameters for openingTemplateOpeningTemplateIdDelete operation in OpeningTemplateApi.
 * @export
 * @interface OpeningTemplateApiOpeningTemplateOpeningTemplateIdDeleteRequest
 */
export interface OpeningTemplateApiOpeningTemplateOpeningTemplateIdDeleteRequest {
    /**
     * 
     * @type {number}
     * @memberof OpeningTemplateApiOpeningTemplateOpeningTemplateIdDelete
     */
    readonly openingTemplateId: number
}

/**
 * Request parameters for openingTemplateOpeningTemplateIdGet operation in OpeningTemplateApi.
 * @export
 * @interface OpeningTemplateApiOpeningTemplateOpeningTemplateIdGetRequest
 */
export interface OpeningTemplateApiOpeningTemplateOpeningTemplateIdGetRequest {
    /**
     * 
     * @type {number}
     * @memberof OpeningTemplateApiOpeningTemplateOpeningTemplateIdGet
     */
    readonly openingTemplateId: number
}

/**
 * Request parameters for openingTemplateOpeningTemplateIdPut operation in OpeningTemplateApi.
 * @export
 * @interface OpeningTemplateApiOpeningTemplateOpeningTemplateIdPutRequest
 */
export interface OpeningTemplateApiOpeningTemplateOpeningTemplateIdPutRequest {
    /**
     * 
     * @type {number}
     * @memberof OpeningTemplateApiOpeningTemplateOpeningTemplateIdPut
     */
    readonly openingTemplateId: number

    /**
     * 
     * @type {UpdateOpeningTemplateDto}
     * @memberof OpeningTemplateApiOpeningTemplateOpeningTemplateIdPut
     */
    readonly updateOpeningTemplateDto?: UpdateOpeningTemplateDto
}

/**
 * Request parameters for openingTemplateOpeningtemplatesByTypeAndPositionGet operation in OpeningTemplateApi.
 * @export
 * @interface OpeningTemplateApiOpeningTemplateOpeningtemplatesByTypeAndPositionGetRequest
 */
export interface OpeningTemplateApiOpeningTemplateOpeningtemplatesByTypeAndPositionGetRequest {
    /**
     * 
     * @type {string}
     * @memberof OpeningTemplateApiOpeningTemplateOpeningtemplatesByTypeAndPositionGet
     */
    readonly date?: string

    /**
     * 
     * @type {number}
     * @memberof OpeningTemplateApiOpeningTemplateOpeningtemplatesByTypeAndPositionGet
     */
    readonly positionId?: number

    /**
     * 
     * @type {number}
     * @memberof OpeningTemplateApiOpeningTemplateOpeningtemplatesByTypeAndPositionGet
     */
    readonly shiftTypeId?: number

    /**
     * 
     * @type {number}
     * @memberof OpeningTemplateApiOpeningTemplateOpeningtemplatesByTypeAndPositionGet
     */
    readonly departmentId?: number

    /**
     * 
     * @type {number}
     * @memberof OpeningTemplateApiOpeningTemplateOpeningtemplatesByTypeAndPositionGet
     */
    readonly facilityId?: number
}

/**
 * Request parameters for openingTemplatePost operation in OpeningTemplateApi.
 * @export
 * @interface OpeningTemplateApiOpeningTemplatePostRequest
 */
export interface OpeningTemplateApiOpeningTemplatePostRequest {
    /**
     * 
     * @type {CreateOpeningTemplate}
     * @memberof OpeningTemplateApiOpeningTemplatePost
     */
    readonly createOpeningTemplate?: CreateOpeningTemplate
}

/**
 * Request parameters for openingTemplateSearchGet operation in OpeningTemplateApi.
 * @export
 * @interface OpeningTemplateApiOpeningTemplateSearchGetRequest
 */
export interface OpeningTemplateApiOpeningTemplateSearchGetRequest {
    /**
     * 
     * @type {number}
     * @memberof OpeningTemplateApiOpeningTemplateSearchGet
     */
    readonly departmentId?: number

    /**
     * 
     * @type {number}
     * @memberof OpeningTemplateApiOpeningTemplateSearchGet
     */
    readonly facilityId?: number

    /**
     * 
     * @type {number}
     * @memberof OpeningTemplateApiOpeningTemplateSearchGet
     */
    readonly shiftTypeId?: number

    /**
     * 
     * @type {number}
     * @memberof OpeningTemplateApiOpeningTemplateSearchGet
     */
    readonly positionId?: number

    /**
     * 
     * @type {number}
     * @memberof OpeningTemplateApiOpeningTemplateSearchGet
     */
    readonly unitId?: number
}

/**
 * OpeningTemplateApi - object-oriented interface
 * @export
 * @class OpeningTemplateApi
 * @extends {BaseAPI}
 */
export class OpeningTemplateApi extends BaseAPI {
    /**
     * 
     * @param {OpeningTemplateApiOpeningTemplateBaseSchedulesGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpeningTemplateApi
     */
    public openingTemplateBaseSchedulesGet(requestParameters: OpeningTemplateApiOpeningTemplateBaseSchedulesGetRequest = {}, options?: AxiosRequestConfig) {
        return OpeningTemplateApiFp(this.configuration).openingTemplateBaseSchedulesGet(requestParameters.departmentId, requestParameters.positionId, requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint accepts a collection of OpenShifts.BusinessObjects.Scheduler.DTOs.UpdateOpeningTemplateDto objects and updates the corresponding opening templates in the system.    Each template is updated with the provided field values, and the overall result of the operation is returned.
     * @summary Performs a bulk update of existing opening templates.
     * @param {OpeningTemplateApiOpeningTemplateBulkUpdateOpeningTemplatesPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpeningTemplateApi
     */
    public openingTemplateBulkUpdateOpeningTemplatesPost(requestParameters: OpeningTemplateApiOpeningTemplateBulkUpdateOpeningTemplatesPostRequest = {}, options?: AxiosRequestConfig) {
        return OpeningTemplateApiFp(this.configuration).openingTemplateBulkUpdateOpeningTemplatesPost(requestParameters.updateOpeningTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OpeningTemplateApiOpeningTemplateGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpeningTemplateApi
     */
    public openingTemplateGet(requestParameters: OpeningTemplateApiOpeningTemplateGetRequest = {}, options?: AxiosRequestConfig) {
        return OpeningTemplateApiFp(this.configuration).openingTemplateGet(requestParameters.facilityId, requestParameters.departmentId, requestParameters.positionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * This endpoint processes an OpenShifts.BusinessObjects.Scheduler.Request.ImportBudgetsRequest that includes filters and default values.    It retrieves matching budgets from the system and generates corresponding opening templates.
     * @summary Imports legacy budget data and converts it into opening templates.
     * @param {OpeningTemplateApiOpeningTemplateImportBudgetsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpeningTemplateApi
     */
    public openingTemplateImportBudgetsPost(requestParameters: OpeningTemplateApiOpeningTemplateImportBudgetsPostRequest = {}, options?: AxiosRequestConfig) {
        return OpeningTemplateApiFp(this.configuration).openingTemplateImportBudgetsPost(requestParameters.importBudgetsRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OpeningTemplateApiOpeningTemplateOpeningTemplateIdDeleteRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpeningTemplateApi
     */
    public openingTemplateOpeningTemplateIdDelete(requestParameters: OpeningTemplateApiOpeningTemplateOpeningTemplateIdDeleteRequest, options?: AxiosRequestConfig) {
        return OpeningTemplateApiFp(this.configuration).openingTemplateOpeningTemplateIdDelete(requestParameters.openingTemplateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OpeningTemplateApiOpeningTemplateOpeningTemplateIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpeningTemplateApi
     */
    public openingTemplateOpeningTemplateIdGet(requestParameters: OpeningTemplateApiOpeningTemplateOpeningTemplateIdGetRequest, options?: AxiosRequestConfig) {
        return OpeningTemplateApiFp(this.configuration).openingTemplateOpeningTemplateIdGet(requestParameters.openingTemplateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OpeningTemplateApiOpeningTemplateOpeningTemplateIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpeningTemplateApi
     */
    public openingTemplateOpeningTemplateIdPut(requestParameters: OpeningTemplateApiOpeningTemplateOpeningTemplateIdPutRequest, options?: AxiosRequestConfig) {
        return OpeningTemplateApiFp(this.configuration).openingTemplateOpeningTemplateIdPut(requestParameters.openingTemplateId, requestParameters.updateOpeningTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OpeningTemplateApiOpeningTemplateOpeningtemplatesByTypeAndPositionGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpeningTemplateApi
     */
    public openingTemplateOpeningtemplatesByTypeAndPositionGet(requestParameters: OpeningTemplateApiOpeningTemplateOpeningtemplatesByTypeAndPositionGetRequest = {}, options?: AxiosRequestConfig) {
        return OpeningTemplateApiFp(this.configuration).openingTemplateOpeningtemplatesByTypeAndPositionGet(requestParameters.date, requestParameters.positionId, requestParameters.shiftTypeId, requestParameters.departmentId, requestParameters.facilityId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {OpeningTemplateApiOpeningTemplatePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpeningTemplateApi
     */
    public openingTemplatePost(requestParameters: OpeningTemplateApiOpeningTemplatePostRequest = {}, options?: AxiosRequestConfig) {
        return OpeningTemplateApiFp(this.configuration).openingTemplatePost(requestParameters.createOpeningTemplate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary One time script
     * @param {OpeningTemplateApiOpeningTemplateSearchGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OpeningTemplateApi
     */
    public openingTemplateSearchGet(requestParameters: OpeningTemplateApiOpeningTemplateSearchGetRequest = {}, options?: AxiosRequestConfig) {
        return OpeningTemplateApiFp(this.configuration).openingTemplateSearchGet(requestParameters.departmentId, requestParameters.facilityId, requestParameters.shiftTypeId, requestParameters.positionId, requestParameters.unitId, options).then((request) => request(this.axios, this.basePath));
    }
}
